export * from './dealerDetails';

export type IPrimaryDetails = {
	id: number;
	dealer_code: string | null;
	dealer_name: string | null;
};

export interface IDealerDetailInitialValue {
	primary_dealer_code: string;
	primary_dealer_name: string;
	primary_details: IPrimaryDetails[];
}

export const defaultPrimaryDetails: IPrimaryDetails[] = [{ id: 0, dealer_code: null, dealer_name: null }];

export const defaultDealerDetailFormInitialValues: IDealerDetailInitialValue = {
	primary_dealer_code: '',
	primary_dealer_name: '',
	primary_details: defaultPrimaryDetails,
};
